import { has, memoize, every, forEach } from 'lodash';
const isNativeCSSSupportsAvailable = has(global, 'CSS.supports');
const FEATURE_RULE_SETS = {
    MULTILINE_CLAMP: {
        display: '-webkit-box',
        '-webkit-line-clamp': 2,
        '-webkit-box-orient': 'vertical',
    },
};
class FeatureDetector {
    constructor() {
        this.isRuleSetAvailable = memoize(this._isRuleSetAvailable, JSON.stringify);
        this.isMultilineClampAvailable = () => this.isRuleSetAvailable(FEATURE_RULE_SETS.MULTILINE_CLAMP);
        this.isRuleSetAvailable.cache = new Map();
    }
    _isRuleSetAvailable(rules) {
        if (isNativeCSSSupportsAvailable) {
            return every(rules, (value, rule) => global.CSS.supports(rule, value));
        }
        const element = document.createElement('div');
        element.style.position = 'absolute';
        element.style.zIndex = '-1';
        document.body.appendChild(element);
        forEach(rules, (value) => (element.style.rule = value));
        const computedStyle = getComputedStyle(element);
        const areAllApplied = every(rules, (value, rule) => computedStyle[rule] === value);
        document.body.removeChild(element);
        return areAllApplied;
    }
}
export const featureDetector = new FeatureDetector();
//# sourceMappingURL=feature-detector.js.map